import * as React from 'react';

import SectionCard from 'bundles/account-settings/components/SectionCard';
import UserContextSwitcher from 'bundles/account-settings/components/sections/user-context-switcher/UserContextSwitcher';
import { useAccountSettingsContextSwitcherGate } from 'bundles/account-settings/contexts/AccountSettingsContextSwitcherGateContext';

/**
 * Renders the Switch Account section only when the gate context is on (Statsig org-scoped-home,
 * exactly one enterprise org from enrollments, and enableOrgScopedHome for that org). When hidden,
 * no card is rendered.
 */
const UserContextSwitcherSection = () => {
  const { shouldRenderContextSwitcher } = useAccountSettingsContextSwitcherGate();

  if (!shouldRenderContextSwitcher) {
    return null;
  }

  return (
    <SectionCard aria-labelledby="user-context-switcher-heading">
      <UserContextSwitcher />
    </SectionCard>
  );
};

export default UserContextSwitcherSection;
